import { createFileRoute } from '@tanstack/react-router'
import PageEntrance from '~components/motion/page-entrance'
import SamsungSmartThingsPortal from '~containers/samsung.smart-things/portal'
import useRouterBackToTerminate from '~containers/samsung.smart-things/portal/hooks/use-router-back-to-terminate'
import useRedirectTo from '~hooks/samsung.smart-things/use-redirect-to'

export const Route = createFileRoute('/samsung/smart-things/(app)/')({
  component: RouteComponent,
  /**
   * @TODO: redirectTo 등의 형태는 여기서 route 단계에서 처리될 수 있게 인계하는 게 유연성이 높음.
   */
})

function RouteComponent() {
  useRedirectTo()
  useRouterBackToTerminate()

  return (
    <PageEntrance>
      <SamsungSmartThingsPortal />
    </PageEntrance>
  )
}
